import * as React from 'react';
import en from 'javascript-time-ago/locale/en';
import Tabs from 'antd/lib/tabs';
import withStyles from 'react-jss';
import Navbar from 'src/components/navbar/Navbar';
import Loader from 'src/components/common/Loader';
import ContainerDetails from './ContainerDetails';
import ContainerDocuments from './ContainerDocuments';
import JavascriptTimeAgo from 'javascript-time-ago';
import ContainerDetailsPage from './ContainerDetailsPagePublic';
import { StylesProps , RouterProps } from 'src/Library/Types';
import { withRouter } from 'react-router';
import { GOOGLE_PLACES_API_URL, MIN_WIDTH, NAVBAR_HEIGHT } from 'src/globals';
import { connect } from 'react-redux';
import { SHIPMENT_TYPE } from './ContainerUtils';
import { useGenericState } from 'src/Library/UseGenericState';
import { message, Row, Col, Tooltip, Modal } from 'antd';
import { getContainerTrackingRoute } from 'src/routing/utils';
import { CardData, Document } from './Interfaces/Shipment.interface';
import {
  showFetchingData,
  retryTracking,
} from 'src/actions/shipmentTrackingActions';
import { fetchShipmentDetailsApi, getContainerDetailsUUID, getBLDetailsUUID, archiveShipment, unarchiveShipment, blTrackingRefresh, containerTrackingRefresh, refreshShipments } from 'src/api/shipmentTracking';
import { BulkApiRequest } from './Interfaces/TypesInShipmentTracking';
import { getBulkRequestArray, getCardType, getShipmentIdArray } from './ShipmentTrackingHelper';
import { ActionCreator, bindActionCreators } from 'redux';
import { ShipsySupportUrl } from 'src/Library/Constants';
import { tokens } from 'src/design-system';
import MapVesselRoute from './VesselTracking/MapVesselRoute';

const TabPane = Tabs.TabPane;
const styles = theme => ({
  NavbarStyle: {
    fontSize: tokens.fontSize.h1,
    display: 'flex',
    alignItems: 'center',
    height: '58px',
    fontWeight: tokens.fontWeight.semibold,
    borderBottom: `1px solid ${tokens.colors.border}`,
    marginBottom: '15px',
  },
  sideBar: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: '100%',
  },
  tabPaneStyle: {
    '& .ant-tabs-tab': {
      textAlign: 'left !important',
      marginBottom: '0 !important',
    },
    '& .ant-tabs-tab-active': {
      color: tokens.colors.primary,
      fontSize: tokens.fontSize.body,
      fontWeight: tokens.fontWeight.semibold,
    },
    '& .ant-tabs-ink-bar': {
      background: tokens.colors.primary,
      width: '4px',
    },
    '& .ant-tabs-left-content': {
      paddingLeft: 0,
    },
  },
  anchor: {
    fontSize: tokens.fontSize.body,
    fontWeight: tokens.fontWeight.semibold,
    color: tokens.colors.primary,
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      color: tokens.colors.primary,
      textDecoration: 'none',
      cursor: 'pointer',
    },
    '&:active': {
      color: tokens.colors.primary,
      textDecoration: 'none',
      cursor: 'pointer',
    },
    '&:visited': {
      color: tokens.colors.primary,
      textDecoration: 'none',
      cursor: 'pointer',
    },
  },
  imgDiv : {
    borderRight: `1px solid ${tokens.colors.border}`,
    display: 'flex',
    alignItems: 'center',
    margin: '10px 0px',
  },
  img : {
    padding: tokens.spacing.sm,
    maxWidth: '100%',
    maxHeight: 80,
  },
  titleCol : {
    fontSize: tokens.fontSize.h3,
    lineHeight: '22px',
    fontWeight: tokens.fontWeight.semibold,
},
labelStyle: {
    fontSize: tokens.fontSize.small,
    lineHeight: '14px',
},
});

const { useEffect, useState } = React;
interface IProps extends
  RouterProps,
  StylesProps<ReturnType<typeof styles>>{
    match;
    newShipmentView?: boolean;
    showFetchingData: (shipments: Record<string, boolean>) => ActionCreator<void>;
    retryTracking: (shipments: BulkApiRequest[]) => ActionCreator<void>;
  }
interface StateProps {
  documents?: Document[];
  containerDetails?: CardData[];
  containerDetailsObject?: CardData;
  tabId: string;
  isMapViewZoomed: boolean;
  mapProps?: any;
}

interface ShipmentDetails {
  containerDetailObjects?: any;
  details?: CardData;
  documents?: Document[];
  shipmentBlContainer?: string;
}

const ContainerDetailsMainPage = (props: IProps) => {

  const [newShipmentView, setNewShipmentView] = useState(props.newShipmentView);
  const [loading, setLoading] = useState<boolean>(true);
  const [reloadPage, setReload] = useState<boolean>(true);
  const [shipment, setShipment] = React.useState<ShipmentDetails>({});

  const map = {
    containerTrackingBL: 'bl',
    containerTrackingHBL: 'hbl',
    containerTrackingContainer: 'container',
    containerTrackingShipment: 'shipment',
  };

  const { history, classes, location, match, showFetchingData } = props;

  const [state, setState] = useGenericState<StateProps>({
    tabId: match?.params?.tabId || 'containers',
    isMapViewZoomed: false,
    mapProps: {},
  });

  const {
    unique_id,
    shipmentType,
  } = match?.params || {};

  async function getShipmentDetails() {
    if (!isPublicLink()) {
      const body = match?.params?.containerId ? {
        shipmentId: match?.params?.id,
        containerId: match?.params?.containerId,
      } : { shipmentId: match?.params?.id };
      return fetchShipmentDetailsApi(body);
    }
    const params = {
      shipmentType,
      id: unique_id,
    }
    if (shipmentType === 'cn_detail') {
      return await getContainerDetailsUUID(params);
    }
    return await getBLDetailsUUID(params);
  }

  function isPublicLink() {
    return !!unique_id;
  }
  
  const loadData = async (isPoll?: boolean) => {
    if (!isPoll) setLoading(true);
    const response = await getShipmentDetails();
    if (response.isSuccess) {
      setShipment(response.data);
      setNewShipmentView(response?.data?.masterData?.newShipmentView || newShipmentView);
    } else {
      message.error(response.errorMessage);
    }
    if (!isPoll) setLoading(false);
  }

  useEffect(() => {
    JavascriptTimeAgo.locale(en);
    loadData()
  }, [reloadPage]);

  useEffect(() => {
    return () => {
      stopDetailsPolling();
    };
  }, []);

  const handleReloadClick = () => {
    loadData();
  }

  const getGotoTab = (shipmentType) => {
    switch (shipmentType) {
      case 'cn': return 'container';
      case 'hbl': return 'hbl';
      case 'bk':
      case 'bl': return 'bl';
      default: return shipmentType;
    }
  }

  function goToContainer() {
    if (isPublicLink()) return;
    const { shipmentType, id } = match.params;
    history.push(getContainerTrackingRoute(
      null,
      location?.state?.from && map[location.state.from] ?
        map[location.state.from] : getGotoTab(shipmentType)),
      { doNotReset: true },
    );
  }
  const handleTabChange = (val) => {
    setState({ tabId: val });
  }

  const renderNavbar = () => {
    return <Navbar
      alwaysShowBack={!isPublicLink()}
      handleBack={goToContainer}
      pageTitle="Shipment Details"
      components={[renderHelpButton()]}
    />;
  };

  const renderDetailsTab = () => {
    return <TabPane
      tab={'Details'}
      key={'details'}
    >
      {renderTopBox()}
      <ContainerDetails
        newShipmentView={newShipmentView}
        shipmentDetails={shipment?.details || {}}
        isHBL={isHBL}
        hblNumber={shipment?.containerDetailObjects?.hblNumber}
        handleReloadClick={handleReloadClick}
        trackingType={getContainerData()?.trackingType ||
          (shipment?.shipmentBlContainer === SHIPMENT_TYPE.CN ? SHIPMENT_TYPE.CN : undefined)}
      />
    </TabPane>;
  };

  const renderDocsTab = () => {
    if (isPublicLink()) return null;
    return <TabPane
      tab={docKey}
      key={'documents'}>
      {renderTopBox()}
      <ContainerDocuments
        isArchived={shipment?.details?.isArchived}
        shipmentDetails={shipment?.details || {}}
        documents={shipment?.documents || []}
        shipmentId={props.match.id}
        handleReloadClick={handleReloadClick}
      />
    </TabPane>;
  };

  let pollingAgent: ReturnType<typeof setTimeout> | null = null;

  const pollApi = () => {
    loadData(true);
    stopDetailsPolling();
    startDetailsPoller();
  };
  
  const startDetailsPoller = () => {
    const pollingFrequncy = 30000;
    if (!pollingAgent) {
      pollingAgent = setTimeout(async () => {
        await pollApi();
      }, pollingFrequncy);
    }
  };
  
  const stopDetailsPolling = () => {
    if (pollingAgent) {
      clearTimeout(pollingAgent);
      pollingAgent = null;
    }
  };

  function renderHelpButton() {
    return <a className={classes.anchor} onClick={() => {
      window.open(ShipsySupportUrl, '_blank');
    }}>Help</a>;
  }

  const getContainerData = () => {
    if (shipment.shipmentBlContainer !== SHIPMENT_TYPE.CN) {
      return shipment?.containerDetailObjects;
    };
    return shipment?.containerDetailObjects?.containerDetails[0];
  };

  // const openExecDetails = () => {
  //   history.push(getShipmentDetailRoute(shipment?.details?.orgType || 'shipper', shipment?.details?.executionId, 'actions/tasks'));
  // };

  const handleArchiveShipment = (selectedShipments) => {
    Modal.confirm({
      title: 'Mark As Complete',
      content: `This will mark selected shipments as completed. Do you wish to proceed?`,
      onOk: async () => archive(selectedShipments),
      onCancel: () => { },
    });
  };
  const handleUnArchiveShipment = () => {
    const shipmentType = location?.state?.mainPageTabId === SHIPMENT_TYPE.CONTAINER ? SHIPMENT_TYPE.CN : location?.state?.mainPageTabId;
    Modal.confirm({
      title: 'Mark As Incomplete',
      content: `This will mark selected shipment as incompleted. Do you wish to proceed?`,
      onOk: async () => await handleUnArchive(shipmentType),
      onCancel: () => {},
    });
  };

  async function handleUnArchive(shipmentType: string) {
    const response = await unarchiveShipment([{
      shipmentType,
      shipmentId: getContainerData().id || getContainerData().shipmentId,
    }]);
    if (response.isSuccess) {
      message.success('Marked as incompleted successfully.');
      handleReloadClick();
    } else {
      message.error(response.errorMessage);
    }
  }
  async function handleRefresh(shipments: CardData[], shipmentIdMap: Record<string, boolean>) {
    const shipmentIds = Object.keys(shipmentIdMap);
    return containerTrackingRefresh({ containerId: shipmentIds });
  }
  async function handleBulkRefresh(shipments: CardData[]) {
    stopDetailsPolling();
    const shipmentIdMap: Record<string, boolean> = {};
    shipments.forEach((item) => {
      shipmentIdMap[item.id] = true;
    });
    showFetchingData(shipmentIdMap);
    const response = await handleRefresh(shipments, shipmentIdMap);
    if (!response.isSuccess) {
      message.error(response.errorMessage);
    }
    loadData(true);
    startDetailsPoller();
  }
  function getApiBody(shipments: CardData[]): BulkApiRequest[] {
    const apiBody = shipments.map(shipment => ({
      shipmentId: shipment.id,
      shipmentType: getCardType(location?.state?.mainPageTabId, shipment),
    }));
    return apiBody;
  }
  async function archive(shipments: CardData[]) {
    const containers = getApiBody(shipments);
    const shipmentIds = containers.map((item) => item.shipmentId);

    const shipmentType = location?.state?.mainPageTabId === SHIPMENT_TYPE.CONTAINER ? SHIPMENT_TYPE.CN :
      location?.state?.mainPageTabId === SHIPMENT_TYPE.HBL ? SHIPMENT_TYPE.BL : location?.state?.mainPageTabId;
    const body = {
      shipmentIds,
      shipmentType,
    };
    const response = await archiveShipment(body);
    if (!response.isSuccess) {
      message.error(response.errorMessage);
    } else {
      message.success('Marked as completed successfully.');
      handleReloadClick();
    }
  }

  const renderContainersTab = () => {
    return <TabPane
      tab = {containerKey}
      key = {'containers'}
    >
      {renderTopBox()}
      <ContainerDetailsPage
        reloadPage={() => setReload(!reloadPage)}
        details={shipment?.details}
        tracking={shipment?.containerDetailObjects?.tracking}
        newShipmentView={newShipmentView}
        trackingDetails={shipment.containerDetailObjects}
        containerDetails={shipment.containerDetailObjects?.containerDetails}
        statusWiseCount={shipment?.containerDetailObjects?.statusWiseCount}
        container={getContainerData()}
        shipmentBlContainer={shipment?.shipmentBlContainer}
        isContainerTab = {!!match?.params?.containerId}
        shipmentLoading={loading}
        tabId={state.tabId}
        mainPageTabId={location?.state?.mainPageTabId}
        handleArchiveShipment ={handleArchiveShipment}
        handleUnArchiveShipment={handleUnArchiveShipment}
        handleRefresh={(item) => handleBulkRefresh([item])}
        isHBL={isHBL}
        toggleMapZoom={(value, mapProps) => toggleMapZoom(value, mapProps)}
      />
    </TabPane>;
  };
  const isHBL = () => {
    return shipment?.containerDetailObjects?.trackingType === SHIPMENT_TYPE.HBL;
  }
  const renderTopBox = () => {
    return <Row gutter={24}
      style={{
        borderBottom: '1px solid #e8e8e8',
        backgroundColor: 'white',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Col span={3} className={classes.imgDiv}>
        <Tooltip title={shipment?.details?.shippingLineName || ''}>
          <img className={classes.img}
            src={shipment?.details?.logoUrl}
          />
        </Tooltip>
      </Col>
      <Col span={6} style={{ alignItems: 'space-between' }}>
        <div
          style={{ marginBottom: 12 }}
          className={classes.titleCol}>
          {!isHBL() && shipment?.details?.internalReferenceNumber}
        </div>
        <Row style={{ marginBottom: 12 }}>
          <Col span={10} className={classes.labelStyle}>{isHBL() ? 'Invoice #' : 'Booking #'}</Col>
          <Col span={14}
            className={classes.labelStyle}
            style={{ fontWeight: 600 }}>
            {isHBL() ? shipment?.details?.invoiceNumberList?.join(', ') : shipment?.details?.bookingNumber}
          </Col>
          </Row>
          <Row style={{ marginBottom: 12 }}>
          <Col span={10} className={classes.labelStyle}>{isHBL() ? 'HBL #' : 'BL #'}</Col>
          <Col span={14} className={classes.labelStyle}
            style={{ fontWeight: 600 }}>
            {isHBL() ? shipment?.containerDetailObjects?.hblNumber : shipment?.details?.blNumber}
            </Col>
        </Row>
        {/* <Row style={{ marginBottom: 12 }}>
          <Col span={10} className={classes.labelStyle}>SE #</Col>
          <Col span={14} className={classes.labelStyle}
            style={{ fontWeight: 600, cursor: 'pointer' }} onClick={openExecDetails}>
            {shipment?.details?.referenceNumber}
          </Col>
        </Row> */}
      </Col>
    </Row>;
  };

  const toggleMapZoom = (isMapViewZoomed, mapProps) => {
    setState({
      isMapViewZoomed,
      mapProps,
    })
  }

  const renderBody = () => {
    if (loading) {
      return <Loader />;
    }
    if (state.isMapViewZoomed) {
      const { mapRoute, center, vesselLocation, timelines,status } = state.mapProps;
      return (
        <div>
          <MapVesselRoute
            mapRoute={mapRoute}
            status={status}
            googleMapURL={GOOGLE_PLACES_API_URL}
            loadingElement={<div style={{ marginTop: 0, height: window.innerHeight - NAVBAR_HEIGHT, width: window.innerWidth }} />}
            containerElement={<div style={{ marginTop: 0, height: window.innerHeight - NAVBAR_HEIGHT, width: window.innerWidth }} />}
            mapElement={<div style={{ marginTop: 0, height: window.innerHeight - NAVBAR_HEIGHT, width: window.innerWidth }} />}
            zoom={3}
            center={center}
            markerPosition={vesselLocation}
            timelines={timelines}
            toggleMapZoom={(value, mapProps) => toggleMapZoom(value, mapProps)}
            isZoomed={state.isMapViewZoomed}
            containerDetailProps={state.mapProps}
          />
        </div>
      )
    }
    return <div
      className={classes.sideBar}>
      <Tabs
        className={classes.tabPaneStyle}
        tabPosition="left"
        defaultActiveKey="containers"
        activeKey={state.tabId}
        tabBarStyle={{ width: '11%' }}
        onChange={handleTabChange}
      >
        {renderDetailsTab()}
        {renderContainersTab()}
        {renderDocsTab()}
      </Tabs>
    </div>
  };

  const noOfDocuments = shipment?.documents?.length || 0;
  const noOfContainers = shipment.containerDetailObjects?.containerDetails?.length || 0;
  const docKey = `Documents (${noOfDocuments || 0})`;
  const containerKey = `Container (${noOfContainers || 0})`;

  return <div
    style={{
      minWidth: MIN_WIDTH,
      backgroundColor: tokens.colors.bgSubtle,
      minHeight: '100vh',
    }}
  >
    {renderNavbar()}
    {renderBody()}
  </div>;
}

const mapStateToProps = ({ masterData }) => {
  return {
    newShipmentView: masterData?.newShipmentView,
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  showFetchingData,
  retryTracking,
}, dispatch);

const ShipmentDetailsStyled = withStyles(styles)(ContainerDetailsMainPage);
const ShipementRouted = withRouter(connect(mapStateToProps, mapDispatchToProps)(ShipmentDetailsStyled));
export default React.memo(ShipementRouted);
